import React, { useState, useRef, useEffect, useCallback } from 'react';
import { sendAssistantMessage } from '../api/client';

const ADMIN_TG = 'https://t.me/Ai_marketing_alex';

const QUICK_QUESTIONS = [
  'Что такое Fix-Hub MD и чем оно мне полезно?',
  'Помоги разобраться с налогами и документами',
  'Найди информацию по строительным нормам',
];

export default function AiAssistant({ visible, onClose }) {
  const [messages, setMessages] = useState([
    { role: 'assistant', content: 'Привет! Я AI-ассистент Fix-Hub MD. Помогу разобраться в приложении, отвечу на вопросы по строительству, налогам, юридическим моментам в Молдове. Чем могу помочь?' },
  ]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const scrollRef = useRef(null);
  const inputRef = useRef(null);

  const scrollToBottom = useCallback(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, []);

  useEffect(() => {
    scrollToBottom();
  }, [messages, loading, scrollToBottom]);

  useEffect(() => {
    if (visible && inputRef.current) {
      setTimeout(() => inputRef.current?.focus(), 300);
    }
  }, [visible]);

  const send = async (text) => {
    const msg = (text || input).trim();
    if (!msg || loading) return;

    const userMsg = { role: 'user', content: msg };
    const newMessages = [...messages, userMsg];
    setMessages(newMessages);
    setInput('');
    setLoading(true);

    try {
      // Send only the conversation history (skip the initial greeting)
      const history = newMessages.slice(1).map(m => ({ role: m.role, content: m.content }));
      const data = await sendAssistantMessage(msg, history.slice(0, -1));
      setMessages(prev => [...prev, { role: 'assistant', content: data.response }]);
    } catch (e) {
      setMessages(prev => [...prev, { role: 'assistant', content: 'Извините, произошла ошибка. Попробуйте ещё раз или свяжитесь с администратором.', error: true }]);
    }
    setLoading(false);
  };

  const callAdmin = () => {
    if (window.Telegram?.WebApp?.openTelegramLink) {
      window.Telegram.WebApp.openTelegramLink(ADMIN_TG);
    } else {
      window.open(ADMIN_TG, '_blank');
    }
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 999,
      display: 'flex', flexDirection: 'column',
      background: 'var(--bg-primary)',
      animation: 'slideUp 0.3s ease',
    }}>
      {/* Header */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: 12,
        padding: '14px 16px',
        paddingTop: 'calc(var(--tg-safe-top, 0px) + 14px)',
        background: 'rgba(10,10,10,0.95)',
        backdropFilter: 'blur(24px)', WebkitBackdropFilter: 'blur(24px)',
        borderBottom: '1px solid var(--border)',
        flexShrink: 0,
      }}>
        <button onClick={onClose} style={{
          background: 'none', border: 'none', color: 'var(--accent)',
          fontSize: 15, fontWeight: 600, cursor: 'pointer', padding: 0,
          fontFamily: 'inherit',
        }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
        </button>
        <div style={{
          width: 36, height: 36, borderRadius: 10,
          background: 'linear-gradient(135deg, var(--accent), #E6B800)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          flexShrink: 0,
        }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0A0A0A" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2a7 7 0 017 7c0 3-2 5.5-4 7l-3 4-3-4c-2-1.5-4-4-4-7a7 7 0 017-7z"/><circle cx="12" cy="9" r="2"/></svg>
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 15, fontWeight: 700 }}>AI Ассистент</div>
          <div style={{ fontSize: 11, color: 'var(--success)', display: 'flex', alignItems: 'center', gap: 4 }}>
            <span style={{ width: 5, height: 5, borderRadius: '50%', background: 'var(--success)' }}></span>
            Online
          </div>
        </div>
        <button onClick={callAdmin} style={{
          background: 'rgba(10,132,255,0.12)', border: '1px solid rgba(10,132,255,0.2)',
          borderRadius: 10, padding: '8px 12px', cursor: 'pointer',
          display: 'flex', alignItems: 'center', gap: 6,
          color: '#0A84FF', fontSize: 12, fontWeight: 600,
        }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0A84FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
          Админ
        </button>
      </div>

      {/* Messages */}
      <div ref={scrollRef} style={{
        flex: 1, overflowY: 'auto', padding: '16px 16px 8px',
        display: 'flex', flexDirection: 'column', gap: 10,
        WebkitOverflowScrolling: 'touch',
      }}>
        {messages.map((msg, i) => (
          <div key={i} style={{
            alignSelf: msg.role === 'user' ? 'flex-end' : 'flex-start',
            maxWidth: '85%',
          }}>
            <div style={{
              background: msg.role === 'user'
                ? 'var(--accent)'
                : msg.error ? 'rgba(255,69,58,0.12)' : 'var(--bg-card)',
              color: msg.role === 'user' ? '#0A0A0A' : 'var(--text-primary)',
              borderRadius: msg.role === 'user' ? '18px 18px 4px 18px' : '18px 18px 18px 4px',
              padding: '10px 14px',
              fontSize: 14, lineHeight: 1.5,
              border: msg.role === 'user' ? 'none' : '1px solid var(--border)',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
            }}>
              {msg.content}
            </div>
          </div>
        ))}

        {/* Quick questions (show only if 1 message) */}
        {messages.length === 1 && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginTop: 4 }}>
            {QUICK_QUESTIONS.map((q, i) => (
              <button key={i} onClick={() => send(q)} style={{
                background: 'var(--bg-card)', border: '1px solid var(--border)',
                borderRadius: 12, padding: '10px 14px', cursor: 'pointer',
                color: 'var(--text-primary)', fontSize: 13, fontWeight: 500,
                textAlign: 'left', fontFamily: 'inherit',
                display: 'flex', alignItems: 'center', gap: 8,
              }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
                {q}
              </button>
            ))}
          </div>
        )}

        {/* Loading indicator */}
        {loading && (
          <div style={{ alignSelf: 'flex-start', maxWidth: '85%' }}>
            <div style={{
              background: 'var(--bg-card)', border: '1px solid var(--border)',
              borderRadius: '18px 18px 18px 4px',
              padding: '12px 18px',
              display: 'flex', gap: 4, alignItems: 'center',
            }}>
              <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--text-tertiary)', animation: 'pulseDot 1.2s ease infinite' }}></span>
              <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--text-tertiary)', animation: 'pulseDot 1.2s ease 0.2s infinite' }}></span>
              <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--text-tertiary)', animation: 'pulseDot 1.2s ease 0.4s infinite' }}></span>
            </div>
          </div>
        )}
      </div>

      {/* Admin call banner */}
      <div onClick={callAdmin} style={{
        margin: '0 16px 8px', padding: '10px 14px',
        background: 'rgba(10,132,255,0.08)', border: '1px solid rgba(10,132,255,0.15)',
        borderRadius: 12, cursor: 'pointer',
        display: 'flex', alignItems: 'center', gap: 10,
        flexShrink: 0,
      }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0A84FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
        <span style={{ fontSize: 12, color: '#0A84FF', fontWeight: 500, flex: 1 }}>Нужна помощь живого человека? Написать администратору</span>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0A84FF" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
      </div>

      {/* Input */}
      <div style={{
        padding: '10px 16px',
        paddingBottom: 'calc(10px + var(--tg-safe-bottom, 0px))',
        background: 'rgba(10,10,10,0.95)',
        backdropFilter: 'blur(24px)', WebkitBackdropFilter: 'blur(24px)',
        borderTop: '1px solid var(--border)',
        display: 'flex', gap: 8, alignItems: 'flex-end',
        flexShrink: 0,
      }}>
        <textarea
          ref={inputRef}
          value={input}
          onChange={e => setInput(e.target.value.slice(0, 1000))}
          onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); } }}
          placeholder="Напишите вопрос..."
          rows={1}
          style={{
            flex: 1, background: 'var(--bg-card)', border: '1px solid var(--border)',
            borderRadius: 20, padding: '10px 16px', fontSize: 15,
            color: 'var(--text-primary)', fontFamily: 'inherit',
            outline: 'none', resize: 'none', maxHeight: 100,
            lineHeight: 1.4,
          }}
        />
        <button
          onClick={() => send()}
          disabled={!input.trim() || loading}
          style={{
            width: 40, height: 40, borderRadius: '50%',
            background: input.trim() && !loading ? 'var(--accent)' : 'var(--bg-elevated)',
            border: 'none', cursor: input.trim() && !loading ? 'pointer' : 'default',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0, transition: 'background 0.2s',
          }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={input.trim() && !loading ? '#0A0A0A' : '#636366'} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="22" y1="2" x2="11" y2="13"/>
            <polygon points="22 2 15 22 11 13 2 9 22 2"/>
          </svg>
        </button>
      </div>
    </div>
  );
}
